import React, { useState, useEffect } from "react";
import { Base_Url } from "../../../API/config";

const PdfViewer = ({ pdfUrl, fileName }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (pdfUrl) {
      setLoading(false);
    }
  }, [pdfUrl]);
  if (!pdfUrl && !fileName) {
    return null;
  }
  const fullPdfUrl = pdfUrl || `${Base_Url}/uploads/admin/events/${fileName}`;
       
  
  return (
    <div className="pdf-viewer-container">
        <div className="pdf-iframe-container">
          <iframe
            src={`${fullPdfUrl}#toolbar=0`}
            className="pdf-iframe"
            title="PDF Viewer"
            width="100%"
            height="400px"
          />
        </div>

    </div>
  );
};

export default PdfViewer;